import { Injectable } from '@angular/core';

export interface ContactInfo {
  email: string;
  phone: string;
  claimsReportingUrl: string;
  supportEmail: string;
}

const ContactsConfig: Record<string, ContactInfo> = {
  de: { email: 'afpsupport@suedvers.de', phone: '+49 761 4582-0', claimsReportingUrl: 'https://my.suedvers.de/afp/login.html', supportEmail: 'MCG.AFPInternational@MarshMMA.com' },
  uk: { email: 'AFPsupport@mcgriff.com', phone: '+1-844-818-6243', claimsReportingUrl: '',  supportEmail: ''},
  fr: { email: 'AFPsupport@mcgriff.com', phone: '+1-844-818-6243', claimsReportingUrl: '',  supportEmail: ''},
  it: { email: 'AFPsupport@mcgriff.com', phone: '+1-844-818-6243', claimsReportingUrl: '',  supportEmail: ''},
  es: { email: 'AFPsupport@mcgriff.com', phone: '+1-844-818-6243', claimsReportingUrl: '',  supportEmail: ''},
  default: { email: 'AFPsupport@mcgriff.com', phone: '+1-844-818-6243', claimsReportingUrl: '',  supportEmail: ''}
};

@Injectable({ providedIn: 'root' })
export class SubdomainConfigService {
  private contactInfo: ContactInfo = ContactsConfig['default'];
  private subdomain: string = 'default';

  private readonly supportedSubdomains = ['de', 'uk', 'fr', 'it', 'es'];

  initialize(): void {
    const host = window.location.hostname;
    const parts = host.split('.');

    const candidate = parts.length > 0 && typeof parts[0] === 'string'
      ? parts[0].toLowerCase()
      : 'default';

    this.subdomain = this.supportedSubdomains.includes(candidate) ? candidate : 'default';
    this.contactInfo = ContactsConfig[this.subdomain] ?? ContactsConfig['default'];
  }

  getSubdomain(): string {
    return this.subdomain;
  }

  getContactInfo(): ContactInfo {
    return this.contactInfo;
  }
}
